<template>
  <v-list dense nav>
    <v-list-group v-if="tripName" v-model="expanded">
      <template v-slot:activator>
        <v-list-item-title>{{ tripName }}</v-list-item-title>
      </template>
      <template v-for="item in items">
        <v-list-group v-if="item.route == 'attendees'" sub-group no-action :key="item.title">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="traveler in travelers"
            :key="traveler.title"
            link
            :to="`/trip/${traveler.route}`"
          >
            <v-list-item-title>{{ traveler.title }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ traveler.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.title" link :to="`/trip/${item.route}`">
          <v-list-item-icon>
            <v-badge
              v-if="item.icon == 'mdi-chat' && newMessages > 0"
              color="red"
              :content="newMessages"
            >
              <v-icon>{{ item.icon }}</v-icon>
            </v-badge>
            <v-icon v-else>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list-group>
  </v-list>
</template>

<script>
// console.log(this.locale)

export default {
  data() {
    return {
      expanded: true,
      travelers: [
        {
          title: this.$t("navbar.menu.admins"),
          icon: "mdi-account-key",
          route: "travelers/admins",
        },
        {
          title: this.$t("navbar.menu.travelers"),
          icon: "mdi-account-multiple",
          route: "travelers/users",
        },
        {
          title: this.$t("navbar.menu.subgroups"),
          icon: "mdi-account-group",
          route: "subgroups",
        },
      ],
      items: [
        {
          title: this.$t("navbar.menu.itinerary"),
          icon: "mdi-view-dashboard",
          route: "itinerary",
        },
        {
          title: this.$t("navbar.menu.feed"),
          icon: "mdi-rss",
          route: "feed",
        },
        {
          title: this.$t("navbar.menu.chat"),
          icon: "mdi-chat",
          route: "chat",
        },
        {
          title: this.$t("navbar.menu.attendees"),
          icon: "mdi-account-multiple",
          route: "attendees",
        },

        {
          title: this.$t("navbar.menu.surveys"),
          icon: "mdi-poll",
          route: "surveys",
        },
        {
          title: this.$t("navbar.menu.files"),
          icon: "mdi-file-document",
          route: "files",
        },
        {
          title: this.$t("navbar.menu.contacts"),
          icon: "mdi-card-account-phone",
          route: "contacts",
        },
        {
          title: this.$t("navbar.menu.cities"),
          icon: "mdi-map",
          route: "cities",
        },
        {
          title: this.$t("navbar.menu.settings"),
          icon: "mdi-cog",
          route: "settings",
        },
        {
          title: this.$t("navbar.menu.reviews"),
          icon: "mdi-star",
          route: "reviews",
        },
      ],
    };
  },
  computed: {
    tripName() {
      return this.$store.state.trip.trip.name;
    },
    newMessages() {
      return Object.values(this.$store.state.trip.chat.conversations).reduce(
        (t, c) => t + c.newMessages,
        0,
      );
    },
  },
};
</script>
